var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiefenwirksamBis5Cm = function SvgTiefenwirksamBis5Cm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Tiefenwirksam_bis_5cm_svg__Ebene_2",
    viewBox: "0 0 85.42 85.42"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Tiefenwirksam_bis_5cm_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.3px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tiefenwirksam_bis_5cm_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.26,
    cy: 13.68,
    r: 5.31,
    className: "Tiefenwirksam_bis_5cm_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.66 1.15v39.2h19.67v31.06H11.09V40.35h19.67V1.15H1.15v83.12h83.12V1.15z",
    className: "Tiefenwirksam_bis_5cm_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.03,
    cy: 55.68,
    r: 5.31,
    className: "Tiefenwirksam_bis_5cm_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.6,
    cy: 45.74,
    r: 4.13,
    className: "Tiefenwirksam_bis_5cm_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.57,
    cy: 58.04,
    r: 6.29,
    className: "Tiefenwirksam_bis_5cm_svg__cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.8,
    cy: 30.62,
    r: 4.13,
    className: "Tiefenwirksam_bis_5cm_svg__cls-1"
  }))));
};
export default SvgTiefenwirksamBis5Cm;